import { apiUrl } from '../config/api'

export async function listSocietyCompliances(societyId) {
  let params = { societyId, brandLabel: window.$brand }
  let url = apiUrl('ListSocietyCompliances')
  return sendReq(params, url)
}

export async function updateSocietyCompliance(params) {
  params.brandLabel = window.$brand
  let url = apiUrl('UpdateSocietyCompliance')
  return sendReq(params, url)
}

export async function deleteSocietyCompliance(id, loggedUserId) {
  let params = { id, loggedUserId, brandLabel: window.$brand }
  let url = apiUrl('DeleteSocietyCompliance')
  return sendReq(params, url, true)
}

export async function listUnassignedCompliances(societyId) {
  let params = { societyId, brandLabel: window.$brand }
  let url = apiUrl('ListUnassignedCompliances')
  return sendReq(params, url)
}

export async function addComplianceToSociety(
  societyId,
  complianceId,
  loggedUserId
) {
  let params = {
    societyId,
    complianceId,
    loggedUserId,
    brandLabel: window.$brand
  }
  let url = apiUrl('AddComplianceToSociety')
  return sendReq(params, url, true)
}

export async function insertComplianceForSociety(params) {
  params.brandLabel = window.$brand

  let url = apiUrl('InsertComplianceForSociety')

  return sendReq(params, url)
}

async function sendReq(params, url, allowEmpty = false) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Cache-Control': 'no-cache, no-store',
      'Pragma': 'no-cache'
    }
  }).catch((error) => console.log(error))

  if (!res) return null
  if (allowEmpty) {
    const text = await res.text()
    return text ? JSON.parse(text) : { status: res.status }
  }
  return res.json()
}
